import { useMemo } from "react";
import { useSettingsStore } from "../stores/index.js";
import { formatHm, formatHmDate, formatRange, pad } from "./format.js";

/** Time formatters bound to the user's 12/24-hour setting. Use in any component
 *  that renders a time-of-day so it honours the Settings → Time format choice. */
export function useTimeFormat() {
  const hour12 = useSettingsStore((s) => s.timeFormat === "12h");
  return useMemo(
    () => ({
      hour12,
      hm: (hour: number, minute: number) => formatHm(hour, minute, hour12),
      hmDate: (d: Date) => formatHmDate(d, hour12),
      range: (loMin: number, hiMin: number) => formatRange(loMin, hiMin, hour12),
      /** Render a stored UTC instant as "YYYY-MM-DD <time>" in DEVICE-LOCAL time,
       *  matching the calendar grid (the task form is the one surface that instead
       *  shows the task's own tz). */
      stamp: (iso: string) => {
        const d = new Date(iso);
        const date = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
        return `${date} ${formatHm(d.getHours(), d.getMinutes(), hour12)}`;
      },
    }),
    [hour12],
  );
}
